"use client";

import { useEffect } from "react";
import { capture } from "@/lib/analytics/events";

/**
 * Fires once per rendered search that has non-empty free text, whatever the
 * result count — `jobs_zero_results` only covers the empty-result half.
 * `$current_url`'s query string is stripped before capture (see
 * `scrubUrlProperties`), so this is the only way to see `q` at all; without
 * it, "relevance-first search results beats newest-first" has no query-text
 * series to measure click-through against.
 */
export function JobsSearchPerformedBeacon({
  query,
  filters,
  resultCount,
}: {
  query: string;
  filters: string;
  resultCount: number;
}) {
  useEffect(() => {
    capture("jobs_search_performed", { query, filters, result_count: resultCount });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
